import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContactsItem } from '../../../ContactInfoModal/ContactsItem';
import CallPhoneIcon from '../../../../public/static/images/phone_call_brown-icon.svg';
import { phoneWithInternationalCode } from '../../../../utils/helpers/common';
import { Icon } from '../../../Icon';
import { Modal } from '../../../ui/Modal';
import { headerStyles, modalStyles, PhonesList } from './styled';
import { BackButtonIconEnum } from '../../../ui/PageHeader/types';

interface BottomPhoneContactsModalProps {
  phones: string[] | null;
  setIsVisible?: (v: boolean) => void;
  isVisible?: boolean;
  contactInfoModalTitle?: string;
}

export const BottomPhoneContactsModal: React.FC<
  BottomPhoneContactsModalProps
> = ({ isVisible, setIsVisible, contactInfoModalTitle, phones }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={!!isVisible}
      onClose={() => setIsVisible?.(false)}
      title={contactInfoModalTitle ?? t('residences.numbers')}
      modalId="contact-us"
      cypress="contact-us"
      modalStyles={modalStyles}
      closeButtonAlign="right"
      headerIcon={BackButtonIconEnum.Close}
      headerStyles={headerStyles}
    >
      <PhonesList data-cy="contacts-modal-content">
        {phones?.map((phone, i) => (
          <ContactsItem
            icon={
              <Icon
                width={17}
                height={17}
                IconComponent={CallPhoneIcon}
                indent={false}
              />
            }
            text={phone}
            key={`phone-number-${i}`}
            path={`tel:${phoneWithInternationalCode(phone)}`}
            index={0}
          />
        ))}
      </PhonesList>
    </Modal>
  );
};
